import { post } from './utils';

const getResults = async params => post(`/calculator/deposit-builder`, params);

export const depositBuilder = {
  getResults
};
